"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureString = void 0;
const constants_1 = require("./constants");
const getStringSize_1 = require("./getStringSize");
const truncateString_1 = require("./truncateString");
const ensureString = (str, options = {}) => {
    const defaultOptions = {
        defaultValue: constants_1.DEFAULT_STR,
        min: 0,
        max: undefined,
    };
    const o = { ...defaultOptions, ...options };
    let safeString = str;
    if (typeof str !== 'string') {
        safeString = o.defaultValue;
    }
    safeString = safeString.trim();
    if (safeString.length < o.min) {
        safeString = o.defaultValue;
    }
    if ((0, getStringSize_1.getStringSize)(safeString) > o.max) {
        safeString = (0, truncateString_1.truncateString)(safeString, o.max);
    }
    return safeString;
};
exports.ensureString = ensureString;
//# sourceMappingURL=ensureString.js.map